import utils from './utils';

const URL = `${BASE_API_URL}/user_tests`;

export default {
    fetchTests: user => utils.get(`${URL}/tests/`, { user }),
    fetchTest: uuid => utils.get(`${URL}/tests/${uuid}/`),
    completeTest: (uuid, answers) => utils.put(`${URL}/tests/${uuid}/`, { answers }),
}



// WEBPACK FOOTER //
// ./src/api/userTests.js